module.exports = __webpack_public_path__ + "img/6c35e9f.png";